import React from "react";
import RigthPanel, { RigthPanelType } from "@/ui-controls/RigthPanel";
import NewIntegrationForm from "@/components/integrations/catalog/NewIntegrationForm";

interface Props {
  isOpen: boolean;
  onDismiss: () => void;
  onSave: () => void;
}

const NewIntegrationPanel = (props: Props) => {
  return (
    <RigthPanel
      header="New Integration"
      isOpen={props.isOpen}
      type={RigthPanelType.small}
      dismissPanel={props.onDismiss}
      childComponent={NewIntegrationForm}
      childProps={{
        onSave: props.onSave,
        onClose: props.onDismiss,
      }}
    />
  );
};

export default NewIntegrationPanel;
